const getters = {
  getRouteTo: state => state.to
}

export default getters
